import { render, staticRenderFns } from "./TermList.vue?vue&type=template&id=554e97f0&scoped=true&"
import script from "./TermList.vue?vue&type=script&lang=js&"
export * from "./TermList.vue?vue&type=script&lang=js&"
import style0 from "./TermList.vue?vue&type=style&index=0&id=554e97f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554e97f0",
  null
  
)

export default component.exports